import type { ReactNode } from "react";

interface SectionLinkProps {
	/** The target section id, without the leading `#`. */
	to: string;
	children: ReactNode;
}

/**
 * In-page link to the section that owns a fact. The docs-writing rule is that a fact
 * appears once per page, so other sections link to its owner instead of restating it.
 */
export function SectionLink({ to, children }: SectionLinkProps) {
	return (
		<a
			href={`#${to}`}
			className="font-medium text-primary underline underline-offset-4 transition-colors hover:text-foreground"
		>
			{children}
		</a>
	);
}
